const BOOKING_TOPUP_RESUME_KEY = 'replayer.bookingTopupResume';
const BOOKING_TOPUP_RESUME_MAX_AGE_MS = 2 * 60 * 60 * 1000;

const storages = () => [window.localStorage, window.sessionStorage];

const isObject = value => value !== null && typeof value === 'object' && !Array.isArray(value);

const isSafeBookingReturnPath = (returnPath, slotId) => {
  if (typeof returnPath !== 'string') return false;
  try {
    const url = new URL(returnPath, 'https://replayer.local');
    const validRoute = ['/player-booking-calendar', '/player-service-booking-calendar'].includes(url.pathname);
    return url.origin === 'https://replayer.local' &&
      validRoute &&
      String(url.searchParams.get('resumeSlotId')) === String(slotId) &&
      url.hash === '';
  } catch (error) {
    return false;
  }
};

const isUsableResume = resume => {
  if (!isObject(resume) || resume.slotId === null || resume.slotId === undefined || resume.slotId === '') return false;
  if (resume.returnPath !== undefined && !isSafeBookingReturnPath(resume.returnPath, resume.slotId)) return false;
  if (resume.bookingDraft !== undefined && resume.bookingDraft !== null && !isObject(resume.bookingDraft)) return false;
  if (resume.resourceType !== undefined && !['field', 'service'].includes(resume.resourceType)) return false;
  return true;
};

export const suggestedBookingTopupAmount = (requiredCredit, availableCredit) => Math.max(
  5,
  Math.ceil(Math.max(0, Number(requiredCredit || 0) - Number(availableCredit || 0)))
);

export const saveBookingTopupResume = data => {
  const value = JSON.stringify({...data, savedAt: Date.now()});
  let saved = false;
  for (const storage of storages()) {
    try {
      storage.setItem(BOOKING_TOPUP_RESUME_KEY, value);
      saved = true;
    } catch (error) {
      // Keep the other storage available for external payment handoffs.
    }
  }
  return saved;
};

export const getBookingTopupResume = () => {
  for (const storage of storages()) {
    try {
      const value = storage.getItem(BOOKING_TOPUP_RESUME_KEY);
      if (!value) continue;
      const resume = JSON.parse(value);
      const expired = !resume.savedAt || Date.now() - Number(resume.savedAt) > BOOKING_TOPUP_RESUME_MAX_AGE_MS;
      if (expired || !isUsableResume(resume)) {
        storage.removeItem(BOOKING_TOPUP_RESUME_KEY);
        continue;
      }
      const {savedAt, ...data} = resume;
      return data;
    } catch (error) {
      try {
        storage.removeItem(BOOKING_TOPUP_RESUME_KEY);
      } catch (storageError) {
        // Try the other browser storage before giving up.
      }
    }
  }
  return null;
};

export const clearBookingTopupResume = () => {
  for (const storage of storages()) {
    try {
      storage.removeItem(BOOKING_TOPUP_RESUME_KEY);
    } catch (error) {
      // The booking remains usable when one browser storage is unavailable.
    }
  }
};
